export default __webpack_public_path__ + "static/media/outgoing-info.b120e7b8.svg";